<template>
  <Container type="card-full" v-loading="loading">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{ project.projectno }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{ project.projectname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目初审</div>
            <div class="view-value">
              {{ +project.projectisqcheck === 1 ? "需要" : "不需要" }}
            </div>
          </div>
          <div class="view-field">
            <div class="view-label">评审方法</div>
            <div class="view-con" style="width: 100%;">
              {{ project.prsflgdesc }}——{{ project.projectdoneflgdesc
              }}<span v-if="project.prsflg !== '2' && project.prsflg !== '6'"
                >——{{ project.projectpricecomputebasisdesc }}</span
              >
            </div>
          </div>
          <div class="view-field" style="display: flex;align-items: center;;" v-if="pbrList.length < 3 && +project.prsflg === 6 ">
            <el-button type="primary" size="small" @click="handleClick">转为符合性检查及价格评比</el-button>
            <span style="font-weight: bold; color: red;margin-left: 2px;">温馨提示：本项目报价数不足3家</span>
          </div>
        </div>
      </div>
    </div>
    <div class="split-line"></div>
    <el-tabs v-model="activeName" type="card" :before-leave="leaveTab">
      <el-tab-pane
        :label="
          +project.projectqcheckflg === 1
            ? '项目初审（已审）'
            : '项目初审（未审）'
        "
        name="sc"
        v-if="+project.projectisqcheck === 1"
      >
        <div v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5">
          <div v-if="+project.projectqcheckflg === 1">
            <pqces-form-check-sum-index
              :activeName="activeName"
              :projectid="$route.params.projectid"
            ></pqces-form-check-sum-index>
          </div>
          <div v-else class="view-alertmsg">评审人未初审</div>
        </div>
        <div v-else>
          <pqces-form
            :activeName="activeName"
            :projectid="$route.params.projectid"
            @change="pqcChange"
          ></pqces-form>
        </div>
      </el-tab-pane>
      <el-tab-pane
        lazy
        :label="
          +project.projectstatus >= 30 ? '评分结果（已评）' : '评分结果（未评）'
        "
        name="pfxm"
      >
        <div v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5">
          <!-- <div v-if="(+project.projectqcheckflg ===1 || +project.projectisqcheck!==1) && +project.projectstatus >= 30"> -->
          <div
            v-if="
              +project.projectqcheckflg === 1 || +project.projectisqcheck !== 1
            "
          >
            <project-scoring-sum-index
              :activeName="activeName"
              :projectid="$route.params.projectid"
            ></project-scoring-sum-index>
          </div>
          <div v-else class="view-alertmsg">评审人未评分</div>
        </div>
        <div v-else>
          <price-mark
            :project="project"
            :projectid="$route.params.projectid"
            :activeName="activeName"
            @change="pricemarkChange"
          ></price-mark>
        </div>
      </el-tab-pane>
      <el-tab-pane
        lazy
        label="评审人信息"
        name="zjxx"
        v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5"
      >
        <pexpert-list
          :project="project"
          :projectid="$route.params.projectid"
          :activeName="activeName"
        ></pexpert-list>
      </el-tab-pane>
      <el-tab-pane
        lazy
        label="审核改分申请"
        name="shxg"
        v-if="+project.projectdoneflg === 3 || +project.projectdoneflg === 5"
      >
        <project-review-apply
          :project="project"
          :projectid="$route.params.projectid"
          :activeName="activeName"
        >
        </project-review-apply>
      </el-tab-pane>
      <el-tab-pane
        lazy
        label="履约分"
        name="lvf"
        v-if="+project.projectdoneflg === 5"
      >
      <projectlyScore   
          :project="project"
          :projectid="$route.params.projectid"
          :activeName="activeName">
      </projectlyScore>
      </el-tab-pane>
    </el-tabs>
  </Container>
</template>
<script>
import request from "@/utils/request";
import PqcesForm from "./pqcesForm";
import PqcesFormCheckSumIndex from "./pqcesFormCheckSumIndex";
import projectScoringSumIndex from "./projectScoringSumIndex";
import projectlyScore from './projectlyScore'
import PriceMarkHandEdit from "./priceMarkHandEdit";
import projectReviewApply from "./projectReviewApply";
import pexpertList from "./pexpertList";
import PriceMark from "./priceMark";
import utils from "../../assets/js/utils";
import dayjs from "dayjs";
import common from "@/mixin/common";

export default {
  name: "projectReviewGcTab",
  mixins: [common],
  data() {
    return {
      activeName: "sc",
      project: {},
      loading: false,
      pbrList: []
     
    };
  },
  async created() {
    await this.getModel();
    await this.getPbrList()
  },
  async activated() {
    await this.getModel();
    await this.getPbrList()
  },
  mounted() {},
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
  },
  watch: {},
  components: {
    PqcesForm,
    PriceMark,
    PqcesFormCheckSumIndex,
    projectScoringSumIndex,
    PriceMarkHandEdit,
    projectReviewApply,
    pexpertList,
    projectlyScore
  },
  methods: {
    handleClick () {
      this.$confirm(`本项目报价人${this.pbrList.length}家，是否转换为符合性检查及价格评比`, "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(async () => {
          await request({
            url: '/xmgl/project/changeJJ',
            method: "get",
            params: { projectid: this.project.projectid }
          })
          this.$router.push({name: 'projectReviewRuleIndex', params: {projectid: this.project.projectid, activeName: 'scrule', type: 1}})
      })
      .catch(() => {});
    },
    pqcChange() {
      this.project.projectqcheckflg = 1;
    },
    pricemarkChange() {
      this.project.projectstatus = 30;
    },
    leaveTab(activeName, oldActiveName) {
      if (
        +this.project.projectdoneflg !== 3 &&
        activeName === "pfxm" &&
        +this.project.projectisqcheck === 1 &&
        +this.project.projectqcheckflg !== 1
      ) {
        return new Promise((resolve, reject) => {
          this.$message.warning("请先资格性审查，再进行价格评分！");
        });
      }
    },
    async getPbrList () {
      this.pbrList = await request({
        url: '/xmgl/pbr/checkBjInfo',
        method: "get",
        params: { projectid: this.project.projectid, pbrtime: this.project.prsbjtimes }
      })
    },
    async getModel() {
      this.loading = true;
      this.project = {};
      let res = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res;
      if (+this.project.projectisqcheck === 1) {
        this.activeName = "sc";
      } else {
        this.activeName = "pfxm";
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
</style>
